import { render, staticRenderFns } from "./personlist.vue?vue&type=template&id=4535df49&"
import script from "./personlist.vue?vue&type=script&lang=js&"
export * from "./personlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports